import * as commonConsts from '../../../../pages/common/CommonConsts';
import { getDocumentsByType } from '../../../../utils/SupportingDocumentHelper';

const getValidators = (props) => [
  {
    fieldName: 'hasUnincorporateConstitutionDocument',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_Unincorporated) {
        return true;
      }

      if (v === null) {
        return false;
      }
      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_Unincorporated,
        commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasUnincorporateStatementObjectDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_Unincorporated) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_Unincorporated,
        commonConsts.DOC_UPLOAD_TYPE_StatementObjects
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasIncorporateCertificateIncDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_IncorporatedAssociationNSW) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_IncorporatedAssociationNSW,
        commonConsts.DOC_UPLOAD_TYPE_CertificateIncorporation
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasIncorporateStatementObjectDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_IncorporatedAssociationNSW) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_IncorporatedAssociationNSW,
        commonConsts.DOC_UPLOAD_TYPE_StatementObjects
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasCompanyGuaranteeCertRegDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_CompanyLimitedGuarantee) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_CompanyLimitedGuarantee,
        commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasCompanyGuaranteeStatementObjDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_CompanyLimitedGuarantee) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_CompanyLimitedGuarantee,
        commonConsts.DOC_UPLOAD_TYPE_StatementObjects
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasCompanyGuaranteeConstitutionDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_CompanyLimitedGuarantee) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_CompanyLimitedGuarantee,
        commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasCompanySharesCertRegDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_CompanyLtdShares) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_CompanyLtdShares,
        commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasCompanySharesStatementObjDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_CompanyLtdShares) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_CompanyLtdShares,
        commonConsts.DOC_UPLOAD_TYPE_StatementObjects
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasCompanySharesConstitutionDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_CompanyLtdShares) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_CompanyLtdShares,
        commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasOtherCertificateDocumentsDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_Other) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(v, commonConsts.ORG_TYPE_Other, commonConsts.DOC_UPLOAD_TYPE_Certificate);

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasOtherConstitutionDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_Other) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_Other,
        commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasOtherStatementObjectDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_Other) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_Other,
        commonConsts.DOC_UPLOAD_TYPE_StatementObjects
      );

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasTrustDeedDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_TrustDeed) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(v, commonConsts.ORG_TYPE_TrustDeed, commonConsts.DOC_UPLOAD_TYPE_TrustDeed);

      return documents.length > 0;
    }
  },
  {
    fieldName: 'hasTrustStatementObjectDocuments',
    fieldValue: props.documents,
    isValid: (v) => {
      if (props.organisationType !== commonConsts.ORG_TYPE_TrustDeed) {
        return true;
      }

      if (v === null) {
        return false;
      }

      const documents = getDocumentsByType(
        v,
        commonConsts.ORG_TYPE_TrustDeed,
        commonConsts.DOC_UPLOAD_TYPE_StatementObjects
      );

      return documents.length > 0;
    }
  }
];

const errorsDefaultValue = {
  hasUnincorporateConstitutionDocument: false,
  hasUnincorporateStatementObjectDocuments: false,
  hasIncorporateCertificateIncDocuments: false,
  hasIncorporateStatementObjectDocuments: false,
  hasCompanyGuaranteeCertRegDocuments: false,
  hasCompanyGuaranteeStatementObjDocuments: false,
  hasCompanyGuaranteeConstitutionDocuments: false,
  hasCompanySharesCertRegDocuments: false,
  hasCompanySharesStatementObjDocuments: false,
  hasCompanySharesConstitutionDocuments: false,
  hasOtherCertificateDocumentsDocuments: false,
  hasOtherConstitutionDocuments: false,
  hasOtherStatementObjectDocuments: false,
  hasTrustDeedDocuments: false,
  hasTrustStatementObjectDocuments: false
};

export { getValidators, errorsDefaultValue };
